<template>
  <form-model title="表单修改" width="700" ref="formModel">
    <Button slot="btn" type="primary" @click="qianzi">提交验收</Button>
  </form-model>
</template>
<script>
import fields from "./forms/fields";
export default {
  data() {
    return {
      title: "",
      forms: [],
      item: {
        itemList: [],
        startTime: Date.now() - 86400000 * 15,
        endTime: Date.now(),
        opinion: "同意",
        title: "",
      },
      searchItem: {},
    };
  },
  methods: {
    //https://cloud.ly-gps.com/cloud-rmm-server-dpm/repair
    reach(v) {
      console.log(v);

      
      this.item.title = v.title;
      this.item.job = v.nodeName;
      this.item.formId = v.docId;
      this.searchItem.id = v.docId;
      this.getFormModel(v.formId);
      return;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    qianzi() {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      this.utils.loading(this, "加载中");
      console.log(this.item);
      this.axios({
        method: "post",
        url: this.serverUrl + "/update",
        data: this.item,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.$refs.formModel.close();
        }
      });
    },

    getDetail() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.serverUrl + "/item",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data;
          console.log(this.forms);
          this.item=data;
          this.$refs.formModel.reach(this.forms, this.item);
          return;
          if (data != null) {
            this.item.itemList = data.itemList;
            for (let i = 0; i < this.forms.length; i++) {
              if (this.forms[i].key == "itemList") {
                this.forms[i].selectItems = data.itemList;
              }
            }
            this.item.id = data.acceptId;
          }
        }
      });
    },
    getFormModel(id) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/form/info",
        data: { id },
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        if (res) {
          var v = res.data.data;
          this.serverUrl = v.serverUrl;
          this.title = v.name;
          this.forms = fields[v.field];
          this.getDetail();
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/biaodanxiugai.vue